<script setup lang="ts">
import { cx } from 'class-variance-authority'
import type { Succesion_Plain } from '@webamboos/admin/src/components/sections/interfaces/Succesion'
import StatementPerson from '~/components/workshop/statement-person.vue'
import { withDefaults, defineProps } from 'vue'

const props = withDefaults(
  defineProps<{
    data: Succesion_Plain | undefined
    large?: boolean
  }>(),
  {
    large: true,
  },
)

const defaultStyling = 'w-5/6 text-2xl font-bold text-gray-900'
const lgWidth = cx(defaultStyling, {
  'lg:w-10/12': props.large,
  'lg:w-5/12': !props.large,
})
</script>

<template>
  <Container
    class="flex border-spacing-3 flex-col items-center justify-center space-y-2 border-b border-gray-200 bg-gray-50 py-12"
  >
    <Heading as="h2" size="caption"> {{ props.data!.eyebrow }}</Heading>
    <div class="flex justify-center text-center">
      <span :class="lgWidth"> {{ props.data!.title }}</span>
    </div>

    <StatementPerson :person="props.data!.team || undefined" />
  </Container>
</template>
